const devtricker_reportedComments = {};

async function devtricker_reportComment(event, button) {
    event.preventDefault();
    event.stopPropagation();

    let userId = devtricker_getTheLoggedUserId();

    if (!userId) {
        devtricker_openSocialLoginModal();
        return;
    }

    let commentId = button.closest('.comment').id.split('-')[2];

    const originalHTML = '<span class=" icon icon-flag " ></span><span>Report</span>';
    const successHTML = '<span class=" icon icon-check " ></span><span>Reported!</span>';
    const errorHTML = '<span class=" icon icon-x " ></span><span>Error!</span>';


    if (!devtricker_reportedComments[commentId]) {

        button.innerHTML = successHTML;
        devtricker_reportedComments[commentId] = await devtricker_ajax_reportComment(commentId);

        if (!devtricker_reportedComments[commentId]) {
            button.innerHTML = errorHTML;
        }
        
    } else {
        button.innerHTML = successHTML;
    }

    setTimeout(() => {
        button.innerHTML = originalHTML;
    }, 3000);

}